import { z } from 'zod';

export const reportSchema = z.object({
  category: z.enum(['THREAT', 'SUSPICIOUS_ACTIVITY', 'MEDICAL', 'HAZARD', 'OTHER'], {
    message: 'validation.categoryRequired',
  }),
  description: z.string().min(1, 'validation.descriptionRequired'),
  location: z.string().optional(),
});
export type ReportFormValues = z.infer<typeof reportSchema>;
